const parseLegacyDate = (dataStr: string) => {
    const date = dataStr?.replace("/Date(", "").replace(")/", "");
    return new Date(+date);
};

export default parseLegacyDate;
